var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"nofound"},[_c('div',{staticClass:"nofound-content"},[_c('h1',[_vm._v("404 Not Found")]),_c('p',[_vm._v("抱歉，您访问的页面不存在。")]),_c('el-link',{attrs:{"type":"primary","href":"/","target":"_blank"}},[_vm._v("返回首页")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }